import { useEffect, useMemo, useState } from 'react';

import { isEU } from 'config/regions';

import { useCurrentUser } from './useCurrentUser';

const useRegion = () => {
  const user = useCurrentUser();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      setLoading(false);
    }
  }, [user]);

  const isEUUser = useMemo(
    () => isEU(user?.countryCode || ''),
    [user?.countryCode]
  );

  return { isEUUser, loading };
};

export default useRegion;
